/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { NavLink, Link } from "react-router-dom";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import { CustomTable } from "./CustomTable";
import crudActions from "../../../../CRUD/redux/actions";
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { TextField } from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import salesActions from "../../../../Sales/Management/redux/actions";

const CustomerProducts = (props) => {
    const { customerGroupdetails, loader } = useSelector(state => state.salesSetupReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);

    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const timeoutRef = useRef(null);
    const limit = 100;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [list, setList] = useState('');
    const [listAll, setListAll] = useState('');
    const [customerId, setCustomerId] = useState('');

    const { history } = props;

    const dispatch = useDispatch();

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Customer Products', history, 'Sales')) {
                loadTasks();
                customerApi();
            }
        }
        return () => {
            dispatch({ type: salesActions.CLEAR_MANAGEMENT_DETAILS_START });
        };
    }, [roleManagement]);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                setList(listAll);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    setList(listAll?.filter((el) => {
                        return (el?.name?.match(new RegExp(search, "i")) ||
                            el?.serialNumber?.match(new RegExp(search, "i")))
                    }));
                }, 500);
            }
        }
    }, [search]);

    const customerApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: salesActions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const customObject = (details, id) => {
        let a = details && details.filter((el) => el.id === id);
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const prevGetList = usePrevious(getList);
    useEffect(() => {
        if (prevGetList !== undefined && getList && prevGetList !== getList) {
            let a = [];
            getData && Object.keys(getData).length > 0 && Object?.entries(getData)?.map(([key, value]) => {
                return a.push({
                    'id': key,
                    'name': value[0]?.customer?.name,
                    'mobile': value[0]?.customer?.mobile,
                    'email': value[0]?.customer?.email,
                    'serialNumber': value[0]?.customer?.serialNo,
                    'count': value?.length
                })
            });
            setList(a);
            setListAll(a)
        }
    }, [getList]);


    const dispatchFilter = (customerId, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (customerId) {
            filter['and'].push({ customerId: customerId });
        }

        if (search !== '') {
            or['or'].push({ status: { like: '%' + search.trim() + '%' } });
        }
        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'v1/schedules/customer-products/customer-summary',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatchFilter(customerId, sortBy, sortOrder);
    });

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(customerId, sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(customerId, sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.CPRODUCT_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: `v1/schedules/customer-products`,
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const handleChangeCustomer = (value) => {
        setCustomerId(value);
        dispatchFilter(value, sortBy, sortOrder);
    }


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} cls={'newImg'} img={SalesIcon} title={'Sales'}
                closeLink={'/sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Customer Products', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Customer Products'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Customer Products', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                fullWidth
                                                id={idNamingConversion('Search', 'customerProducts', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Products', 'Action', 'All Customer') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All Customers "}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={customerDetails}
                                                    customClasses={classes.customWidth172P}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    id={idNamingConversion('All Customers', 'customerProducts', 'DropDown')}
                                                    parentValue={customObject(customerDetails, customerId)}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            handleChangeCustomer(data);
                                                        }
                                                    }}
                                                    searchType={(s) => customerApi(s)}
                                                    onChange={(data) => handleChangeCustomer(data.id)}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Products', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'customerProducts', 'Link')}
                                                    onClick={() => loadImportExportData('Customer Products')}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Customer Products', 'create', 'Sales') &&
                                                <Link
                                                    id={idNamingConversion('Add Customer Products', 'customerProducts', 'Link')}
                                                    to={"/sales/setup/customer-products/create"}
                                                    className={clsx(classes.customLink)} >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Customer Products</span>
                                                </Link>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <CustomTable
                                loadTasks={() => dispatchFilter(customerId, sortBy, sortOrder)}
                                details={list}
                                loadMore={loadMore}
                                roleManagement={roleManagement}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>

            <ImportExport
                handleClose={() => setImportVisible(false)}
                visible={importVisible}
                title={'Customer Products'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={customerGroupdetails}
                loadTasks={() => { dispatchFilter(customerId, sortBy, sortOrder) }}
            />
        </React.Fragment>
    )
}
export default CustomerProducts